import {
  MaintenanceAlert,
  MaintenanceNotification,
  Toaster,
} from '@branch-messenger/willow-ui'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'

import { DialogProvider } from '@/context'
import { useAnalyticsPageView } from '@/hooks/useAnalyticsPageView'
import { UseCacheSearchParamsOptions } from '@/hooks/useCacheSearchParams/types'
import { useCacheSearchParams } from '@/hooks/useCacheSearchParams/useCacheSearchParams'
import { globalStyles } from '@/styles/stitches.config'

import { RootLayout } from './components/RootLayout'

const maintenanceComponentId = 't3bqc4bhkbh5'

const routeSearchParamsToCache: UseCacheSearchParamsOptions['routeSearchParamsToCache'] =
  {
    '/_authenticated/account/_dashboard/': true,
    '/_authenticated/account/_dashboard/onDemandPay/': true,
  }

export const RootRouteComponent = () => {
  globalStyles()
  useAnalyticsPageView()
  useCacheSearchParams({ routeSearchParamsToCache })
  return (
    <>
      <Toaster />
      <MaintenanceAlert componentId={maintenanceComponentId} />
      <MaintenanceNotification componentId={maintenanceComponentId} />
      <DialogProvider>
        <RootLayout />
        <ReactQueryDevtools
          buttonPosition="bottom-left"
          initialIsOpen={false}
        />
        {process.env.NODE_ENV !== 'production' && (
          <TanStackRouterDevtools
            position="bottom-right"
            initialIsOpen={false}
          />
        )}
      </DialogProvider>
    </>
  )
}
